module.exports = __webpack_public_path__ + "img/icon_arrow_l.4b7a62ee.svg";